import type { FaireProductEntity } from "../../entity_types/product";

export const p_5rjg9gh45d: FaireProductEntity = {
  token: "p_5rjg9gh45d",
  type: "product",
  name: '50 4x6" Thank You For Your Order Cards - Kraft Bulk Inserts',
  brandToken: "b_e4kpbeuvwn",
  brandName: "T Marie",
  imageUrl:
    "https://cdn.faire.com/fastly/da6651c42d7ec163507a161acb9322459c4d2838eb99f2b402eefb83d5fc2491.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c20a817629718541cecb02f6667aaedd80dfc3972a8d02d7c0ec239438edd7ae.jpeg",
    "https://cdn.faire.com/fastly/512c93918d69064beb065ec58c7bd1064f503ff156cccd9087ed39dd74ed65fc.jpeg",
    "https://cdn.faire.com/fastly/d28e3ec0e00cdd8f307b0dc622dae597ef418b6797eef78e72b19f4f00611d10.jpeg",
    "https://cdn.faire.com/fastly/a634f68ab2800fe40349816f17b114db7a52bcf3e527a6524e0f55f6c35b8a3e.jpeg",
    "https://cdn.faire.com/fastly/fa01beb5446d3acac61171fe0068c80bf9391541c8d3932326b167d2c6dc1608.jpeg",
  ],
  priceDollars: 5.95,
  description:
    "• Each unit includes 50 postcards of the same design\n• 4x6” uncoated both sides\n• Postcards come shrink wrapped together as a set of 50\n\nThe Perfect Special Touch for All Of Your Orders!\n\nSometimes it’s those small personal touches that really make an impression on customers. And when it comes to unboxing an order in the mail, it’s the perfect opportunity to really wow your customers! That’s how you and create buzz and inspire loyal, long-term buyers.\n\nCustomers will love the warm message on these charming rustic cards, and we leave plenty of space on the card for you to add your own personalized message or signature. Some business owners like to stamp their business info at the bottom or add a logo sticker to the back of the cards.\n\nOur thank you cards can be shared in so many ways. Sales reps use them as notecards and send them in the mail. Some e-commerce sellers tape the cards to the inside the lid of boxes, while other businesses nestle the card into shopping bags.",
  tags: [],
  msrpDollars: 11.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:20.881Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
